export default __webpack_public_path__ + "static/media/emkanat.ae649f8f.jpg";